const {
  getContentPublishDate,
  getContentModificationDate,
  getContentDateData
} = require('./date/dateUtils');
const {
  getCardImage,
  getBackgroundImage,
  getCardSponsored,
  mapContentToCardData,
  removeAuthorsAndDateFromCardData,
  removeAttributesFromCardData,
  removeTaxonomyElementsFromCardData
} = require('./card/cardUtils');
const {
  getSecondaryHubPages,
  getHubPages,
  getHubPage
} = require('./hubPage/hubPageUtils');
const { getRelatedShowPageData } = require('./show/showUtils');
const {
  getTaxonomyIds,
  getTaxonomies,
  getTaxonomyAncestorSlugs,
  getPrimaryTaxonomySlug,
  getPrimaryTaxonomyData
} = require('./taxonomy/taxonomyUtils');
const {
  getMainImages,
  getAllImagesFromContent
} = require('./image/imageUtils');

const { getPromos, getDataSubdirectory } = require('./contentUtils');

module.exports = {
  getTaxonomyIds,
  getRelatedShowPageData,
  getTaxonomies,
  getTaxonomyAncestorSlugs,
  getSecondaryHubPages,
  getHubPages,
  getHubPage,
  getPrimaryTaxonomySlug,
  getPrimaryTaxonomyData,
  getCardImage,
  getBackgroundImage,
  getCardSponsored,
  mapContentToCardData,
  getContentPublishDate,
  getContentModificationDate,
  getContentDateData,
  getPromos,
  getDataSubdirectory,
  removeAuthorsAndDateFromCardData,
  removeAttributesFromCardData,
  removeTaxonomyElementsFromCardData,
  getMainImages,
  getAllImagesFromContent
};
